const gradients = {
};

export { gradients };
